import React from "react";
import FormComponent from "../../components/form/FormComponent";

const Form = () => {
  return (
    <div className="w-full h-full ">
      <div className="h-full ">
        <FormComponent />
      </div>
    </div>
  );
};

export default Form;
